var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('HeaderAgency'),_c('HeroDigitalAgency'),_c('ServiceAgency'),_c('FeatureAgency'),_c('TeamAgency'),_c('ProjectAgency'),_c('NewsletterThree'),_c('ContactAgency'),_c('FooterMain'),_c('OffcanvasSearchBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }